// src/router/logs.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const logsBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Logs',
        to: 'Logs'
    }
]

export default [
    {
        path: '/logs',
        name: 'Logs',
        component: () => import('@/views/Logs/LogListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Logs',
            breadcrumb: logsBreadCrumb
        },
    },
    {
        path: '/logs/novo',
        name: 'LogNovo',
        component: () => import('@/views/Logs/NovoLogPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Log',
            breadcrumb: [
                ...logsBreadCrumb,
                {
                    label: 'Novo Cliente',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/logs/:id/edit',
        name: 'LogEdit',
        component: () => import('@/views/Logs/NovoLogPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Cliente',
            breadcrumb: [
                ...logsBreadCrumb,
                {
                    label: 'Novo Log',
                    to: 'LogNovo'
                }
            ]
        }
    }

];
